import styled from 'styled-components'

export const StyledDSIImage = styled.div`
  @media print {
    -webkit-print-color-adjust: exact;
    .fyu {
      background: #fff;
    }
    .fy_rndr {
      width: 328px !important;
      height: 184.5px !important;
      top: 30px !important;
      left: 0px !important;
      background: #fff;
      .fy_cnvs {
        transform: translate(0px, 0px) scale(0.171833) !important;
      }
    }
    .fy_tgs {
      width: 960px !important;
      height: 540px !important;
      top: 20px !important;
      left: 0px !important;
      transform: translate(0px, 0px) scale(0.343667) !important;
    }
  }
`
